var app = angular.module('leonardo');

var TaskService = function(BaseRestService, TemplateService, $q, RestangularProvider, Upload, ConfigThemeService) {

  var service = new BaseRestService('action-items', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('action-items', false, function(action_item) {
      action_item.addRestangularMethod('setRecurrence', 'post', 'recurrence');
      action_item.addRestangularMethod('setPriority', 'post', 'priority');
      action_item.addRestangularMethod('setScheduled', 'post', 'schedule');
      action_item.addRestangularMethod('playWorkOrder', 'post', 'mark-as-in-progress');
      action_item.addRestangularMethod('cannotDo', 'post', 'cannot-do');
      action_item.addRestangularMethod('dismiss', 'post', 'dismiss');
      action_item.addRestangularMethod('addAttachments', 'post', 'attachments');
      action_item.addRestangularMethod('assignUsers', 'post', 'assign-users');
      action_item.addRestangularMethod('assignVendors', 'post', 'assign-vendors');
      action_item.addRestangularMethod('addDynamicFormData', 'post', 'dynamic-form-data');
      action_item.addRestangularMethod('resolveTask', 'post', 'mark-as-complete', {});
      action_item.addRestangularMethod('resolveTaskForApproval', 'post', 'mark-as-complete/?for_approval=true', {});
      action_item.addRestangularMethod('requestApproval', 'post', 'submit-for-approval');
      action_item.addRestangularMethod('getTriggerData', 'get', 'trigger-data');
      action_item.addRestangularMethod('reopen', 'post', 'reopen');
      action_item.addRestangularMethod('snooze', 'post', 'snooze');
      action_item.addRestangularMethod('play', 'post', 'play', undefined, undefined, {});
      action_item.addRestangularMethod('pause', 'post', 'pause', undefined, undefined, {});
      action_item.addRestangularMethod('deactivate', 'post', 'deactivate', undefined, undefined, {});
      action_item.addRestangularMethod('changeDate', 'post', 'change-date');
      return action_item;
    });
  });

  service.TYPE_PROPERTY = '0';
  service.TYPE_ACCOUNT_USE = '1';

  service.TYPE_TASK_DEFAULT = '0';
  service.TYPE_TASK_DOCUMENT = '1';
  service.TYPE_TASK_WORKFLOW = '2';
  service.TYPE_TASK_WORK_ORDER = '3';


  service.DOCUMENT_TYPE_EXPIRED = '0';
  service.DOCUMENT_TYPE_NOTICE = '1';
  service.DOCUMENT_TYPE_MISSING = '2';

  service.STATUS_PENDING = '0';
  service.STATUS_SOLVED = '1';
  service.STATUS_CANNOT_DO = '2';
  service.STATUS_DISMISS = '3';
  service.STATUS_WO = '4';
  service.STATUS_FUTURE = '5';
  service.STATUS_UPCOMING = '6';
  service.STATUS_APPROVAL_IN_PROGRESS = '7';
  service.STATUS_APPROVAL_APPROVED = '8';
  service.STATUS_APPROVAL_REJECTED = '9';
  service.STATUS_APPROVAL_RETURN_SUBMITTER = '10';


  service.MRB_STATUS_SCHEDULED = '0';
  service.MRB_STATUS_OVERDUE = '1';
  service.MRB_STATUS_UPCOMING = '2';
  service.MRB_STATUS_COMPLETED = '3';
  service.MRB_STATUS_CANNOT_DO = '4';

  service.MRB_STATUS_OPTIONS = [
    {
      id: service.MRB_STATUS_SCHEDULED,
      name: 'Due'
    },
    {
      id: service.MRB_STATUS_OVERDUE,
      name: 'Overdue'
    },
    {
      id: service.MRB_STATUS_UPCOMING,
      name: 'Upcoming'
    },
    {
      id: service.MRB_STATUS_COMPLETED,
      name: 'Completed'
    },
    {
      id: service.MRB_STATUS_CANNOT_DO,
      name: 'Cannot Do'
    },
  ];

  service.WORKFLOW_STATUS_PENDING = '0';
  service.WORKFLOW_STATUS_STARTED = '1';
  service.WORKFLOW_STATUS_PAUSED = '2';
  service.WORKFLOW_STATUS_STOPPED = '3';
  service.WORKFLOW_STATUS_SOLVED = '4';
  service.WORKFLOW_CANNOT_DO = '5';
  service.WORKFLOW_STATUS_APPROVAL_IN_PROGRESS = '6';
  service.WORKFLOW_STATUS_APPROVAL_APPROVED = '7';
  service.WORKFLOW_STATUS_APPROVAL_REJECTED = '8';
  service.WORKFLOW_STATUS_APPROVAL_RETURN_SUBMITTER = '9';

  service.DEVICE_TYPE_DESKTOP = '0';
  service.DEVICE_TYPE_IOS = '1';
  service.DEVICE_TYPE_ANDROID = '2';

  service.PARENT_TYPE_TASK = '31';
  service.PARENT_TYPE_DOCUMENT = '43';
  service.PARENT_TYPE_WORKFLOW = '48';

  service.CURRENT_PERIOD = '0';
  service.PREVIOUS_PERIOD = '1';

  service.CATEGORY_CODE = '17';

  service.DEVICE_OPTIONS = [
    { id: service.DEVICE_TYPE_DESKTOP,
      name: 'PC'
    },
    { id: service.DEVICE_TYPE_IOS,
      name: 'IOS'
    },
    { id: service.DEVICE_TYPE_DESKTOP,
      name: 'ANDROID'
    }
  ];



  service.getApprovalSteps = function(params) {
    var defer = $q.defer();
    RestangularProvider.all('action-items').customGET('my-approval-steps', params).then(function (data){
      var results = data.results || data;
      defer.resolve(results.map(i => i.toString()));
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getRevisions = function(params) {
    var defer = $q.defer();
    RestangularProvider.all('action-items').customGET('my-revision-numbers', params).then(function (data){
      var results = data.results || data;
      var revisions = [{id:0, label:'Has no revisions'}];
      angular.forEach(results, function(result) {
        var label = result > 1 ? 'Revisions' : 'Revision';
        revisions.push({id: result, label: result + ' ' + label});
      });
      defer.resolve(revisions);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getSubmitters = function(params) {
    return RestangularProvider.all('action-items').customGET('my-approval-submitters', params);
  };

  service.getCurrentApprovers = function(params) {
    return RestangularProvider.all('action-items').customGET('my-current-approvers', params);
  };

  service.getReports = function(params) {
    return RestangularProvider.all('action-items').customGET('report', params);
  };

  service.getApprovalReview = function(id) {
    return RestangularProvider.one('action-items', id).customGET('approval-review');
  };

  service.getApprovalLogPDF = function(id) {
    return RestangularProvider.one('action-items', id, ).customGET('approval-log-pdf');
  };

  service.getSequenceApprovers = function(id) {
    return RestangularProvider.one('action-items', id).customGET('check-sequence-approvers');
  };

  service.getPastDue = function(params) {
    return RestangularProvider.all('action-items').customGET('get-past-due', params);
  };

  service.clearPastDue = function (params) {
    return RestangularProvider.all('action-items').customDELETE('clear-past-due', params);
  };

  service.taskFinder = function (id, params) {
    return RestangularProvider.one('action-items', id).customGET('admin-finder', params);
  };

  service.get = function(id) {
    var defer = $q.defer();
    RestangularProvider.one('action-items', id).customGET('').then(function(data){
      data.setRecurrence = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'recurrence');
      };
      data.setPriority = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'priority');
      };
      data.cannotDo = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'cannot-do');
      };
      data.dismiss = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'dismiss');
      };
      data.addAttachments = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'attachments');
      };
      data.reopen = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'reopen');
      };
      data.snooze = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'snooze');
      };
      data.assignUsers = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'assign-users');
      };
      data.assignVendors = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'assign-vendors');
      };
      data.addDynamicFormData = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'dynamic-form-data');
      };
      data.play = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'play');
      };
      data.pause = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'pause');
      };
      data.deactivate = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'deactivate');
      };
      data.setScheduled = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'schedule');
      };
      data.playWorkOrder = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'mark-as-in-progress');
      };
      data.resolveTask = function(values) {
        return Upload.upload({
                url: ConfigThemeService.generateURL('/api/2.0/action-items/' + id + '/mark-as-complete/'),
                data: values
              });
      };
      data.resolveTaskForApproval = function(values) {
        return Upload.upload({
                url: ConfigThemeService.generateURL('/api/2.0/action-items/' + id + '/mark-as-complete/?for_approval=true'),
                data: values
              });
      };
      data.requestApproval = function(values) {
        return Upload.upload({
                url: ConfigThemeService.generateURL('/api/2.0/action-items/' + id + '/submit-for-approval/'),
                data: values
              });
      };
      data.getTriggerData = function(params) {
        return RestangularProvider.one('action-items', id).customGET('trigger-data', params);
      };
      data.changeDate = function(values) {
        return RestangularProvider.one('action-items', id).customPOST(values, 'change-date');
      };
      defer.resolve(data);
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getTasklist = function(block, params) {
    var defer = $q.defer();
    RestangularProvider.all('action-items').customGET(block, params).then(function(data){
      angular.forEach(data.results, function(action_item){
        action_item.deactivate = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'deactivate');
        };
        action_item.pause = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'pause');
        };
        action_item.play = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'play');
        };
        action_item.addDynamicFormData = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'dynamic-form-data');
        };
        action_item.assignVendors = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'assign-vendors');
        };
        action_item.setPriority = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'priority');
        };
        action_item.setRecurrence = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'recurrence');
        };
        action_item.cannotDo = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'cannot-do');
        };
        action_item.dismiss = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'dismiss');
        };
        action_item.addAttachments = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'attachments');
        };
        action_item.reopen = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'reopen');
        };
        action_item.snooze = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'snooze');
        };
        action_item.assignUsers = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'assign-users');
        };
        action_item.assignVendors = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'assign-vendors');
        };
        action_item.addDynamicFormData = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'dynamic-form-data');
        };
        action_item.play = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'play');
        };
        action_item.pause = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'pause');
        };
        action_item.deactivate = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'deactivate');
        };
        action_item.setScheduled = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'schedule');
        };
        action_item.playWorkOrder = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'mark-as-in-progress');
        };
        action_item.resolveTask = function(values) {
          return Upload.upload({
                  url: ConfigThemeService.generateURL('/api/2.0/action-items/' + this.id + '/mark-as-complete/'),
                  data: values
                });
        };
        action_item.resolveTaskForApproval = function(values) {
          return Upload.upload({
                  url: ConfigThemeService.generateURL('/api/2.0/action-items/' + this.id + '/mark-as-complete/?for_approval=true'),
                  data: values
                });
        };
        action_item.requestApproval = function(values) {
          return Upload.upload({
                  url: ConfigThemeService.generateURL('/api/2.0/action-items/' + this.id + '/submit-for-approval/'),
                  data: values
                });
        };
        action_item.getTriggerData = function(params) {
          return RestangularProvider.one('action-items', this.id).customGET('trigger-data', params);
        };
        action_item.patch = function(values) {
          return RestangularProvider.one('action-items', this.id).patch(values);
        };
        action_item.changeDate = function(params) {
          return RestangularProvider.one('action-items', this.id).customPOST(params, 'change-date');
        };
      });
      defer.resolve(data);
    }, function(error) {
      defer.reject(error);
    })
    .catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.workspace = function(params) {
    var defer = $q.defer();
    RestangularProvider.all('action-items').customGET('workspace', params).then(function(data){
      angular.forEach(data.results, function(action_item){
        action_item.setRecurrence = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'recurrence');
        };
        action_item.setPriority = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'priority');
        };
        action_item.cannotDo = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'cannot-do');
        };
        action_item.dismiss = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'dismiss');
        };
        action_item.addAttachments = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'attachments');
        };
        action_item.reopen = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'reopen');
        };
        action_item.snooze = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'snooze');
        };
        action_item.assignUsers = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'assign-users');
        };
        action_item.assignVendors = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'assign-vendors');
        };
        action_item.addDynamicFormData = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'dynamic-form-data');
        };
        action_item.play = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'play');
        };
        action_item.pause = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'pause');
        };
        action_item.deactivate = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'deactivate');
        };
        action_item.setScheduled = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'schedule');
        };
        action_item.playWorkOrder = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'mark-as-in-progress');
        };
        action_item.resolveTask = function(values) {
          return Upload.upload({
                  url: ConfigThemeService.generateURL('/api/2.0/action-items/' + this.id + '/mark-as-complete/'),
                  data: values
                });
        };
        action_item.resolveTaskForApproval = function(values) {
          return Upload.upload({
                  url: ConfigThemeService.generateURL('/api/2.0/action-items/' + this.id + '/mark-as-complete/?for_approval=tue'),
                  data: values
                });
        };
        action_item.requestApproval = function(values) {
          return Upload.upload({
                  url: ConfigThemeService.generateURL('/api/2.0/action-items/' + this.id + '/submit-for-approval/'),
                  data: values
                });
        };
        action_item.getTriggerData = function(params) {
          return RestangularProvider.one('action-items', this.id).customGET('trigger-data', params);
        };
        action_item.patch = function(values) {
          return RestangularProvider.one('action-items', this.id).patch(values);
        };
        action_item.changeDate = function(values) {
          return RestangularProvider.one('action-items', this.id).customPOST(values, 'change-date');
        };
      });
      defer.resolve(data);
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.taskIsSnoozable = function(task) {
    if (!isEmpty(task.approval_sequences)) return false;
    if (task && !isNull(task.recurrence_type)) {
      switch (task.recurrence_type.toString()) {
        case TemplateService.RECURRENCE_DAILY:
          return false;
        case TemplateService.RECURRENCE_FIXED_DATE:
          return true;
      }
    }
    var alternatives = service.getRecurrenceAlternatives(task.recurrence_type, task.recurrence);
    return alternatives.length !== 0;
  };

  service.getRecurrenceAlternatives = function(recurrence_type, recurrence) {
    var alternatives = [];
    var options = null;
    if ((recurrence_type !== null) && (recurrence_type !== undefined) && (recurrence_type !== '')) {
      switch (recurrence_type.toString()) {
        case TemplateService.RECURRENCE_WEEKLY:
          options = TemplateService.RECURRENCE_WEEKLY_OPTIONS;
          break;
        case TemplateService.RECURRENCE_MONTHLY:
          options = TemplateService.RECURRENCE_MONTHLY_OPTIONS;
          break;
        case TemplateService.RECURRENCE_YEARLY:
          options = TemplateService.RECURRENCE_YEARLY_OPTIONS;
          break;
      }
    }
    if (options) {
      angular.forEach(options, function(option) {
        if (!recurrence[option]) {
          alternatives.push(option);
        }
      });
    }
    return alternatives;
  };

  service.getSnoozeOptions = function(recurrence_type, recurrence) {
    if ((recurrence_type !== null) && (recurrence_type !== undefined) && (recurrence_type !== '')) {
      switch (recurrence_type.toString()) {
        case TemplateService.RECURRENCE_FIXED_DATE:
          return service.getSnoozeOptionsRecurrenceFixedDate(recurrence);
        case TemplateService.RECURRENCE_WEEKLY:
          return service.getSnoozeOptionsRecurrenceWeekly(recurrence);
        case TemplateService.RECURRENCE_MONTHLY:
          return service.getSnoozeOptionsRecurrenceMonthly(recurrence);
        case TemplateService.RECURRENCE_YEARLY:
          return service.getSnoozeOptionsRecurrenceYearly(recurrence);
      }
    }
  };

  service.getSnoozeOptionsRecurrenceFixedDate = function(recurrence) {
    var date = moment();
    var options = [
      {
        label: 'Tomorrow',
        value: date.add(1, 'days').format('YYYY-MM-DD')
      }
    ];
    angular.forEach([3, 5, 7], function(days) {
      var d = date.add(days, 'days');
      options.push({
        label: d.format('ddd, MMMM D'),
        value: d.format('YYYY-MM-DD')
      });
    });
    return options;
  };

  service.getSnoozeOptionsRecurrenceWeekly = function(recurrence) {
    var d = moment();
    var options = [];
    while (options.length != 4) {
      d = d.add(1, 'days');
      var key = TemplateService.RECURRENCE_WEEKLY_OPTIONS[d.isoWeekday() - 1];
      if (!recurrence[key]) {
        options.push({
          label: d.format('ddd, MMMM D'),
          value: d.format('YYYY-MM-DD')
         });
      }
    }
    return options;
  };

  service.getSnoozeOptionsRecurrenceYearly = function(recurrence) {
    var d = moment().date(1);
    var options = [];
    while (options.length !== 4) {
      d.add(1, 'months');
      var key = TemplateService.RECURRENCE_YEARLY_OPTIONS[d.month()];
      if (!recurrence[key]) {
        var lastDay = moment(d);
        lastDay.add(1, 'months').subtract(1, 'days');
        options.push({
          label: d.format('ddd, MMMM D') + ' - ' + lastDay.format('ddd, MMMM D'),
          value: lastDay.format('YYYY-MM-DD')
         });
      }
    }
    return options;
  };

  service.getSnoozeOptionsRecurrenceMonthly = function(recurrence) {
    var d = moment().date(1);
    var currentIndex = 3;
    if (moment().date() <= 7) {
      currentIndex = 0;
    }
    else if (moment().date() <= 14) {
      currentIndex = 1;
    }
    else if (moment().date() <= 21) {
      currentIndex = 2;
    }
    var options = [];
    currentIndex = (currentIndex + 1) % 4;
    while (options.length !== 4) {
      if (currentIndex === 0) {
        d.add(1, 'months');
      }
      var key = TemplateService.RECURRENCE_MONTHLY_OPTIONS[currentIndex];
      if (!recurrence[key]) {
        var firstDay = moment(d), lastDay = moment(d);
        switch (currentIndex) {
          case 0:
            firstDay.date(1);
            lastDay.date(7);
            break;
          case 1:
            firstDay.date(8);
            lastDay.date(14);
            break;
          case 2:
            firstDay.date(15);
            lastDay.date(21);
            break;
          case 3:
            firstDay.date(22);
            lastDay.date(1).add(1, 'months').subtract(1, 'days');
            break;
        }
        options.push({
          label: firstDay.format('ddd, MMMM D') + ' - ' + lastDay.format('ddd, MMMM D'),
          value: lastDay.format('YYYY-MM-DD')
        });
      }
      currentIndex = (currentIndex + 1) % 4;
    }
    return options;
  };

  return service;
};

app.factory('TaskService', ['BaseRestService', 'TemplateService', '$q', 'Restangular', 'Upload', 'ConfigThemeService', TaskService]);
